/**
 * Page-level SEO for every static page. Service and industry pages carry their own
 * metaTitle / metaDesc inside data/services.js and data/industries.js.
 * Keep titles <= 60 characters and descriptions between 120 and 160 characters.
 * This file is also read by scripts/postbuild.js to build the sitemap and static page heads.
 */
export const PAGE_SEO = {
  "/": {
    name: "Home",
    title: "Athlevo IT Solution | Fitness & Wellness Digital Solutions",
    description: "Grow your fitness, sports, or wellness business with custom websites, gym management software, membership systems, booking platforms, mobile apps, and SEO.",
    priority: "1.0", changefreq: "weekly",
  },
  "/about": {
    name: "About Us",
    title: "About Athlevo IT Solution | Fitness Technology Partner",
    description: "Meet Athlevo IT Solution, a Bhopal-based team building websites, software, apps and automation for gyms, studios, academies and wellness businesses.",
    priority: "0.8", changefreq: "monthly",
  },
  "/services": {
    name: "Services",
    title: "Fitness Website Development & Business Software | Athlevo",
    description: "Explore Athlevo's full service catalogue: fitness websites, gym management software, CRM, booking systems, mobile apps, e-commerce, SEO and automation.",
    priority: "0.9", changefreq: "weekly",
  },
  "/industries": {
    name: "Industries",
    title: "Fitness, Sports & Wellness Industries | Athlevo",
    description: "Industry-specific websites, software and apps for gyms, yoga studios, sports academies, swimming clubs, martial arts, dance, spas and membership clubs.",
    priority: "0.9", changefreq: "weekly",
  },
  "/solutions": {
    name: "Solutions",
    title: "Fitness Business Solutions by Function | Athlevo",
    description: "Custom fitness business software and digital solutions for customer acquisition, memberships, scheduling, operations and digital commerce.",
    priority: "0.8", changefreq: "monthly",
  },
  "/portfolio": {
    name: "Portfolio",
    title: "Portfolio: Websites, Apps & CRM Projects | Athlevo",
    description: "Browse websites, online stores, Android apps, admin panels and CRM systems delivered for clients across India, Australia, the UK, the USA and Canada.",
    priority: "0.8", changefreq: "monthly",
  },
  "/testimonials": {
    name: "Testimonials",
    title: "Client Testimonials & Reviews | Athlevo IT Solution",
    description: "Read what clients say about working with Athlevo IT Solution on websites, SEO, mobile apps, CRM integration, custom software and digital marketing.",
    priority: "0.7", changefreq: "monthly",
  },
  "/process": {
    name: "Our Process",
    title: "Our Process: From Idea to Digital Solution | Athlevo",
    description: "How Athlevo IT Solution delivers fitness websites, software and apps: discover, plan, design, develop and test, then launch and keep improving.",
    priority: "0.7", changefreq: "monthly",
  },
  "/contact": {
    name: "Contact",
    title: "Contact Athlevo IT Solution | Discuss Your Project",
    description: "Contact Athlevo IT Solution by form, WhatsApp, email or phone to discuss a website, software, app or SEO project. Open 24 hours, based in Bhopal, India.",
    priority: "0.9", changefreq: "monthly",
  },
  "/privacy-policy": {
    name: "Privacy Policy",
    title: "Privacy Policy | Athlevo IT Solution",
    description: "How Athlevo IT Solution collects, uses and protects information you send through its inquiry forms, WhatsApp and email.",
    priority: "0.3", changefreq: "yearly",
  },
  "/terms-and-conditions": {
    name: "Terms & Conditions",
    title: "Terms & Conditions | Athlevo IT Solution",
    description: "Terms of use for athlevoitsolution.com, covering website content, third-party services, intellectual property and governing law.",
    priority: "0.3", changefreq: "yearly",
  },
  "/sitemap": {
    name: "Sitemap",
    title: "Sitemap | Athlevo IT Solution",
    description: "Browse every page on the Athlevo IT Solution website: services, industries, solutions, portfolio, testimonials, process, contact and legal pages.",
    priority: "0.3", changefreq: "monthly",
  },
};
export const LAST_MODIFIED = "2026-11-05";
